import React from 'react'
import { TypeAnimation } from 'react-type-animation'
import{BsChevronDown} from 'react-icons/bs'
import { HashLink } from 'react-router-hash-link'
const Home = () => {
  return (
    <div id='home' className='lg:w-full md:bg-center  w-screen h-screen relative flex justify-center '>
       {/* image */}
       <div className='h-full bg-home  bg-cover  bg-no-repeat  bg-center  w-full  z-0 absolute'>
       </div>
       {/* mask and main content */}
     <div className='h-full w-full flex flex-col justify-center ml-56 lg:ml-0 items-center bg-neutral-950 bg-opacity-90  absolute z-10 '>
      {/* content */}
       <div className='opacity-100 text-white  z-12 mt-16 text-center'>
        <h4  className='text-6xl opacity-100 capitalize mb-7'>welcome</h4>
        <span className='opacity-100 capitalize text-5xl font-bold xl:text-4xl xl:pl-2 sm:tracking-wide tracking-widest mb-6'>  
        <TypeAnimation
      sequence={[
        // 'Namaste',
        // 1000, 
        'i am  Hardik chopra..',
        1000, 
        'I am a freelancer ...',
        1000,
        'I am a frontend Developer...',
        1000,
      ]}
      wrapper="span"
      speed={10}
      // style={{ fontSize: '2em', display: 'inline-block' }}
      repeat={Infinity}
      />
        </span>
        <p opacity-100 className='mt-8 capitalize text-xl text-white font-bold tracking-wider'>based in ludhiana,punjab</p>
        <HashLink smooth to="/#Contact">
        <button className='transition-all delay-100 ease in opacity-100 mt-10 font-bold border-2 p-2 capitalize w-36 h-14 border-red hover:bg-red hover:text-white text-red rounded-full'>hire me</button>
        </HashLink>
       </div>
     {/* scroll down animation */}
     <div className='mt-28 z-10 '>
     <HashLink smooth to="/#about">
     <BsChevronDown className='animate-bounce cursor-pointer   ' fill='gray' fontSize={"36px"} />
     </HashLink>
     </div>
     </div>
    </div>
  )
}

export default Home
